import { hub } from 'services/hub';
import { bugsnagNotify } from 'containers/ErrorBoundary/utils';

/**
 * Edits an existing scene/rule on the specified hub via WebSocket API.
 *
 * @param {string} serial - Hub serial number (e.g., "90004631")
 * @param {Object} rule - Scene/rule configuration object
 * @param {string} rule._id - Unique identifier of the scene/rule to edit
 * @param {boolean} rule.enabled - Whether the rule is enabled
 * @param {string} rule.name - Display name for the rule
 * @param {Array} rule.when - Array of trigger blocks
 * @param {Array} rule.then - Array of action blocks
 * @param {Array} rule.else - Array of else action blocks
 * @param {Array} rule.exceptions - Array of exception blocks
 * @param {Array<string>} rule.house_modes - Array of house mode IDs
 *
 * @returns {Promise<Object>} Promise resolving to API response object
 *
 * @throws {Error} API error — caller is responsible for user notification
 *
 * @example
 * try {
 *   await hubScenesEdit("90004631", { _id: "scene-abc123", enabled: true, name: "My Scene", ... });
 * } catch (error) {
 *   console.error('Failed to edit scene:', error);
 * }
 */
export const hubScenesEdit = (serial, rule) =>
    new Promise((resolve, reject) => {
        hub.scenes.edit(serial, { _id: rule._id, eo: rule }, resolve, (error) => {
            bugsnagNotify(error, { serial, rule });
            reject(error);
        });
    });
